const HEADER_HEIGHT = 64

/** Smooth-scroll to a section, landing just below the sticky header. */
export function scrollToSection(id: string) {
  const el = document.getElementById(id)
  if (!el) return
  const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
}
